import {getCurrentUserLogin} from '@github-ui/client-env'
// eslint-disable-next-line no-restricted-imports
import {useToastContext} from '@github-ui/toast/ToastContext'
import {useCallback} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {pinCommentMutation} from '../mutations/pin-comment-mutation'
import {unpinCommentMutation} from '../mutations/unpin-comment-mutation'

export function usePinnedComment() {
  const environment = useRelayEnvironment()
  const {addToast} = useToastContext()

  const pinComment = useCallback(
    (commentId: string, issueId: string) => {
      pinCommentMutation({
        environment,
        input: {id: commentId},
        viewerLogin: getCurrentUserLogin(),
        issueId,
        onError: () => {
          // eslint-disable-next-line @github-ui/dotcom-primer/toast-migration
          addToast({
            type: 'error',
            message: 'Failed to pin comment',
          })
        },
      })
    },
    [environment, addToast],
  )

  const unpinComment = useCallback(
    (commentId: string, issueId: string) => {
      unpinCommentMutation({
        environment,
        input: {id: commentId},
        issueId,
        onError: () => {
          // eslint-disable-next-line @github-ui/dotcom-primer/toast-migration
          addToast({
            type: 'error',
            message: 'Failed to unpin comment',
          })
        },
      })
    },
    [environment, addToast],
  )

  return {
    pinComment,
    unpinComment,
  }
}
